import React, { Fragment, useEffect, useState } from 'react';
import DatagridGroup from '../../../table/DatagridGroup';
import DatagridHeader from '../../../table/DatagridHeader';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { translate } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import * as _ from 'lodash';

function TblGroup({ t, partSnap, typeIndex }) {
  const [isPc, setIsPc] = useState(false);
  const [isRoom, setIsRoom] = useState(true);
  const [heightTb, setHeightTb] = useState(360);

  useEffect(() => {
    const heightTb = 360 - (typeIndex === 1 ? 0 : typeIndex === 2 ? 100 : 145);
    setHeightTb(heightTb);
  }, [typeIndex]);

  const _handleSortData = (sortName, sortType) => {
    // let _csData;
    // if (sortName === 'lot') {
    //   _csData = _.sortBy(partSnap, [
    //     function (obj) {
    //       return StringToInt(obj[sortName]);
    //     },
    //   ]);
    // } else {
    //   _csData = _.sortBy(partSnap, [sortName]);
    // }
    // if (sortType !== 'asc') _csData = _csData.reverse();
    // setCsData(_csData);
  };

  return (
    <Fragment>
      <div className="tbl-fix-header">
        <table className="table table-bordered table-fix">
          <colgroup>
            <col width="5.5%"></col>
            {/** sym */}
            <col width="3.4%"></col>
            {/** tc */}
            <col width="3.4%"></col>
            {/** tran */}
            <col width="3.4%"></col>
            {/** san */}
            <col width="3.4%"></col>
            {/** gia 3 */}
            <col width="3.9%"></col>
            {/** kl 3 */}
            <col width="3.4%"></col>
            {/** giá 2 */}
            <col width="3.9%"></col>
            {/** kl 2 */}
            <col width="3.4%"></col>
            {/** gia 1 */}
            <col width="3.9%"></col>
            {/** kl 1 */}
            <col width="3.4%"></col>
            {/** gia khop */}
            <col width="4.2%"></col>
            {/** kl khop */}
            <col width="3.4%"></col>
            {/** +/- */}
            <col width="3.4%"></col>
            {/** gia 1 */}
            <col width="3.9%"></col>
            {/** kl 1 */}
            <col width="3.4%"></col>
            {/** gia 2 */}
            <col width="3.9%"></col>
            {/** kl 2 */}
            <col width="3.4%"></col>
            {/** gia 3 */}
            <col width="3.9%"></col>
            {/** kl 3 */}
            <col width="4.9%"></col>
            {/** tong kl */}
            <col width="3.8%"></col>
            {/** cao */}
            <col width="3.4%"></col>
            {/** thap */}
            <col width="3.4%"></col>
            {/** tb */}
            <col width="3.5%"></col>
            {/** nn mua */}
            <col width="3.5%"></col>
            {/** nn ban */}
            <col width="3.9%"></col>
            {/** dư mua */}
            <col width="3.9%"></col>
            {/** dư ban */}
          </colgroup>
          <thead className="bb-1-haft ">
            <DatagridHeader
              isPc={isPc}
              setIsPc={setIsPc}
              isRoom={isRoom}
              setIsRoom={setIsRoom}
              t={t}
              // sortTable={_handleSortData}
            />
          </thead>
        </table>
      </div>
      {!isMobile && (
        <PerfectScrollbar style={{ height: `calc(100vh - ${heightTb}px)` }}>
          <DatagridGroup
            resource={partSnap}
            className="table table-bordered table-fix"
            isPc={isPc}
            isRoom={isRoom}
          />
        </PerfectScrollbar>
      )}
      {isMobile && (
        <div
          style={{
            width: '100%',
            height: `calc(100vh - ${heightTb}px)`,
            overflowY: 'auto',
          }}
        >
          <DatagridGroup
            resource={partSnap}
            className="table table-bordered table-fix"
            isPc={isPc}
          />
        </div>
      )}
    </Fragment>
  );
}

export default translate('translations')(TblGroup);
